import React, { useId } from 'react'

// Logo "átomo" (estilo React) com cada aro de uma cor própria.
//
// Uso:
//   <AtomLogo size={60} />
//   <AtomLogo size={60} ring1="#1d8b5a" ring2="#0a5a73" ring3="var(--amber, #d97706)" nucleus="#003e4f" />
//   <AtomLogo spin={false} />            // sem animação
//   <AtomLogo spinSeconds={20} />        // gira mais rápido
//
// Props:
//   size        : lado em px (quadrado). Padrão 60.
//   ring1/2/3   : cor de cada aro (elipse). Padrão verde / teal / âmbar.
//   nucleus     : cor do núcleo central.
//   spin        : true para girar (padrão true).
//   spinSeconds : duração de uma volta em segundos (padrão 70, igual ao seu CSS).
//   strokeWidth : espessura dos aros.
export const AtomLogo = ({
    size = 60,
    ring1 = '#e8503a',   // verde
    ring2 = '#2aa6c4',   // teal claro
    ring3 = '#f2b705',   // âmbar
    nucleus = '#3a3f54', // teal escuro
    spin = true,
    spinSeconds = 70,
    strokeWidth = 8,
    className
}) => {
    const uid = useId().replace(/:/g, '')
    const spinId = `spin-${uid}`

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label="Logo"
            className={className}
        >
            {/* a animação de rotação fica embutida no próprio SVG,
                então não depende do CSS externo */}
            <style>{`
                @keyframes ${spinId} { to { transform: rotate(360deg); } }
                .${spinId}-rings {
                    transform-origin: 100px 100px;
                    ${spin ? `animation: ${spinId} ${spinSeconds}s linear infinite;` : ''}
                }
                @media (prefers-reduced-motion: reduce) {
                    .${spinId}-rings { animation: none; }
                }
            `}</style>

            <g className={`${spinId}-rings`} fill="none" strokeWidth={strokeWidth}>
                {/* três aros (elipses) girados em 60° cada — cada um com sua cor */}
                <ellipse cx="100" cy="100" rx="86" ry="34" stroke={ring1} />
                <ellipse cx="100" cy="100" rx="86" ry="34" stroke={ring2}
                    transform="rotate(60 100 100)" />
                <ellipse cx="100" cy="100" rx="86" ry="34" stroke={ring3}
                    transform="rotate(120 100 100)" />
            </g>

            {/* núcleo central (não gira) */}
            <circle cx="100" cy="100" r="16" fill={nucleus} />
        </svg>
    )
}

export default AtomLogo
